// Copyright (c) 2023 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateProduct = (state, action) =>
     action.data;

export default (state = getDefaultState().isValid, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_DUPLICATE_PIN_PLATE]: updateProduct
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/reducers/validate-pin.js